import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';

export const setSelectedNoteId = mutatorAction(
    'setSelectedNoteId',
    (selectedNoteId: string | undefined) => {
        getStore().selectedNoteId = selectedNoteId;
    }
);
